import React,{useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import Details from '../components/Details/Details'
import MovieVideos from '../components/MovieVideos/MovieVideos';
import {fetchData, fetchData2} from '../Utils/FetchData'
import {motion} from 'framer-motion'
import Similar from '../components/Similar/Similar';

function MovieDetails() {
  const [currentMovie, setCurrentMovie] = useState({})
  const [videoTrailer, setVideoTrailer] = useState([])
  const [playTrailer, setPlaytrailer] = useState(false)
  const [similarMovies, setSimilarMovies] = useState([]) 

  const play = () => {
    setPlaytrailer(true)
  }

  const stop =() => {
    setPlaytrailer(false)
  }
    const {id} = useParams();

    useEffect(()=>{
      const MovieDetail = async () => {
        const dataMovie = await fetchData2(`https://api.themoviedb.org/3/movie/${id}?api_key=${process.env.REACT_APP_API_KEY}`);
        setCurrentMovie(dataMovie)
      
      const trailer = await fetchData(`https://api.themoviedb.org/3/movie/${id}/videos?api_key=${process.env.REACT_APP_API_KEY}`)
      setVideoTrailer(trailer)

      const similar = await fetchData(`https://api.themoviedb.org/3/movie/${id}/similar?api_key=${process.env.REACT_APP_API_KEY}`)
      setSimilarMovies(similar)
    }
      MovieDetail()
    }, [id])
  return (
    <motion.div
    initial={{width:0}}
    animate={{width:"100%"}}
    exit={{x:window.innerWidth, tranition: {duration:  0.1}}} style={{padding:'10px 20px'}}>
      <Details currentMovie={currentMovie} play={play}/>
      <MovieVideos videoTrailer={videoTrailer} playTrailer={playTrailer} stop={stop}/>
      <Similar similarMovies={similarMovies} />
    </motion.div>
  )
}

export default MovieDetails



